import React, { FC } from 'react'

import css from './UserInfo.module.scss'
import Rate from '../../common/Rate/Rate'
import cx from 'classnames'

interface IUserInfo {
  name: string
  rate: number
  classNames?: {
    name?: string
    avatar?: string
    container?: string
    rate?: string
  }
}

const UserInfo: FC<IUserInfo> = ({ name, rate, classNames }) => {
  return (
    <div className={cx(css.userInfo, classNames?.container)}>
      <div className={cx(css.avatar, classNames?.avatar)}>
        {name?.replaceAll(' ', '')[0]}
      </div>
      <div>
        <p title={name} className={cx(css.name, classNames?.name)}>
          {name}
        </p>
        <Rate rate={rate} className={cx(css.rate, classNames?.rate)} />
      </div>
    </div>
  )
}

export default UserInfo
